import { observer } from 'mobx-react';
import { ChangeEvent, FC, useCallback } from 'react';
import OrderCurbside from '../OrderCurbside/OrderCurbside';
import { useCheckoutStoreContext } from '../../context';
import { appStore } from 'src/mobx/appStore';
import { localeStore } from 'src/mobx/localesStore';
import { TBooleanInNumber } from 'src/types/main';
import Input from 'src/view/components/Controls/Input/Input';
import CustomerPicker, { ICustomerPickerOption } from 'src/view/components/Controls/Pickers/CustomerPicker/CustomerPicker';
import Switcher from 'src/view/components/Controls/Switcher/Switcer';
import Text, { TEXT } from 'src/view/components/Text/Text';
import './style.scss';

const OrderForSomeoneElse: FC = observer((): JSX.Element | null => {
  const { store: checkoutStore } = useCheckoutStoreContext();

  const onChange = useCallback((is_order_for_someone_else: TBooleanInNumber) => {
    checkoutStore.toggleOrderForSomeoneElse(is_order_for_someone_else);
  }, []);

  const changeStrangerPhone = useCallback((value: string) => {
    checkoutStore.changeStrangerInfo('phone', value);
  }, []);

  const changeStrangerName = useCallback((event: ChangeEvent<HTMLInputElement>) => {
    checkoutStore.changeStrangerInfo('name', event.target.value);
  }, []);

  const changeStranger = useCallback((option?: ICustomerPickerOption) => {
    if (option?.customer) {
      checkoutStore.changeStrangerInfo('name', option.customer.name);
      checkoutStore.changeStrangerInfo('phone', option.customer.mobile);
    }
  }, []);

  if (!appStore.settings?.allow_order_for_else) return null;

  return (
    <div className="checkout-order-for-someone-else">
      {/* turn-on switcher */}
      <div className="d-flex align-items-center">
        <Switcher status={checkoutStore.params.is_order_for_someone_else} onChange={onChange} />
        <Text type={TEXT.SWITCHER_LABEL} text="order_for_sb" />
      </div>

      {/* order for someone else content */}
      {checkoutStore.params.is_order_for_someone_else ? (
        <div className="d-flex flex-column mt-4">
          {/* mobile field */}
          <div className="d-flex align-items-center mb-3">
            <Text type={TEXT.ORDER_FIELD} text="txt_mobile" required />
            <CustomerPicker
              error={checkoutStore.validatorErrors.stranger_phone}
              onChange={changeStrangerPhone}
              onSelect={changeStranger}
              phone={checkoutStore.dependencies.stranger.phone}
            />
          </div>
          {/* name field */}
          <div className="d-flex align-items-center">
            <Text type={TEXT.ORDER_FIELD} text="hint_name" />
            <Input
              onChange={changeStrangerName}
              value={checkoutStore.dependencies.stranger.name}
              placeholder={localeStore.t('hint_name')}
              className="input-mini family-medium text-size-16 text-elipsis"
            />
          </div>

          {checkoutStore.params.is_curbside ? <OrderCurbside checkoutStore={checkoutStore} className="mt-3" /> : null}
        </div>
      ) : null}
    </div>
  );
});

export default OrderForSomeoneElse;
